import { on, reducer } from "ts-action";
import { LoadingStatus } from "../../withLoadingState";
import {
  activateWorkingHoursSchedule,
  activateWorkingHoursScheduleFailure,
  activateWorkingHoursScheduleSuccess,
  createWorkingHoursSchedule,
  createWorkingHoursScheduleFailure,
  createWorkingHoursScheduleSuccess,
  deleteWorkingHoursSchedule,
  deleteWorkingHoursScheduleFailure,
  deleteWorkingHoursScheduleSuccess,
  getWorkingHoursSchedulesSuccess,
  updateWorkingHoursScheduleName,
  updateWorkingHoursScheduleNameFailure,
  updateWorkingHoursScheduleNameSuccess,
  resetWorkingHoursSchedule,
  selectWorkingHoursSchedule,
} from "../../../actions";
import { WorkingHoursSchedule } from "../../../../../../types";

type WorkingHoursScheduleState = {
  status: LoadingStatus | undefined;
  workingHoursSchedules: WorkingHoursSchedule[];
  selectedWorkingHoursSchedule?: WorkingHoursSchedule;
  activeWorkingHoursSchedule: Partial<WorkingHoursSchedule>;
};

export default reducer<WorkingHoursScheduleState>(
  [
    on(getWorkingHoursSchedulesSuccess, (state, { payload }) => ({
      ...state,
      workingHoursSchedules: payload,
      activeWorkingHoursSchedule:
        payload.find(
          (schedule) => schedule.is_active
        ) || state.activeWorkingHoursSchedule,
      selectedWorkingHoursSchedule: payload.find(
        (schedule) => schedule.id === state.selectedWorkingHoursSchedule?.id
      ) || state.selectedWorkingHoursSchedule,
    })),

    on(selectWorkingHoursSchedule, (state, { payload }) => ({
      ...state,
      selectedWorkingHoursSchedule: state.workingHoursSchedules.find(
        (schedule) => schedule.id === payload
      ),
    })),
    on(createWorkingHoursSchedule, (state) => ({
      ...state,
      status: LoadingStatus.loading,
    })),
    on(createWorkingHoursScheduleSuccess, (state, { payload }) => ({
      ...state,
      status: LoadingStatus.success,
      workingHoursSchedules: [...state.workingHoursSchedules, payload],
      selectedWorkingHoursSchedule: payload,
    })),
    on(createWorkingHoursScheduleFailure, (state) => ({
      ...state,
      status: LoadingStatus.failed,
    })),

    on(updateWorkingHoursScheduleName, (state) => ({
      ...state,
      status: LoadingStatus.loading,
    })),
    on(updateWorkingHoursScheduleNameSuccess, (state, { payload }) => ({
      ...state,
      status: LoadingStatus.success,
      workingHoursSchedules: state.workingHoursSchedules.map((schedule) =>
        schedule.id === payload.id ? { ...schedule, name: payload.name } : schedule
      ),
      selectedWorkingHoursSchedule:
        state.selectedWorkingHoursSchedule?.id === payload.id
          ? { ...state.selectedWorkingHoursSchedule, name: payload.name }
          : state.selectedWorkingHoursSchedule,
      activeWorkingHoursSchedule:
        state.activeWorkingHoursSchedule?.id === payload.id
          ? { ...state.activeWorkingHoursSchedule, name: payload.name }
          : state.activeWorkingHoursSchedule,
    })),
    on(updateWorkingHoursScheduleNameFailure, (state) => ({
      ...state,
      status: LoadingStatus.failed,
    })),

    on(deleteWorkingHoursSchedule, (state) => ({
      ...state,
      status: LoadingStatus.loading,
    })),
    on(deleteWorkingHoursScheduleSuccess, (state, { payload }) => ({
      ...state,
      status: LoadingStatus.success,
      workingHoursSchedules: state.workingHoursSchedules.filter(
        (schedule) => schedule.id !== payload
      ),
      selectedWorkingHoursSchedule: state.workingHoursSchedules.find(
        (schedule) => schedule.is_active
      ),
    })),
    on(deleteWorkingHoursScheduleFailure, (state) => ({
      ...state,
      status: LoadingStatus.failed,
    })),

    on(activateWorkingHoursSchedule, (state) => ({
      ...state,
      status: LoadingStatus.loading,
    })),
    on(activateWorkingHoursScheduleSuccess, (state, { payload }) => {
      const targetIndex = state.workingHoursSchedules.findIndex(
        (schedule) => payload === schedule.id
      );
      return {
        ...state,
        status: LoadingStatus.success,
        workingHoursSchedules: state.workingHoursSchedules.map((schedule) => {
          if (schedule.id === payload) {
            return {
              ...schedule,
              is_active: true,
            };
          }
          return schedule;
        }),
        activeWorkingHoursSchedule: {
          ...state.workingHoursSchedules[targetIndex],
          is_active: true,
        },
        selectedWorkingHoursSchedule: state.selectedWorkingHoursSchedule
          ? { ...state.selectedWorkingHoursSchedule, is_active: true }
          : state.selectedWorkingHoursSchedule,
      };
    }),
    on(activateWorkingHoursScheduleFailure, (state) => ({
      ...state,
      status: LoadingStatus.failed,
    })),
    on(resetWorkingHoursSchedule, (state) => ({
      ...state,
      status: undefined,
    })),
  ],
  {
    status: undefined,
    workingHoursSchedules: [],
    selectedWorkingHoursSchedule: undefined,
    activeWorkingHoursSchedule: {},
  }
);
